import {Types} from "@Common/types";

export const GetImageQuality = ({
    imageInfo,
    areaInfo              = null,
    photoQualitySettings  = null,
}:{
    imageInfo             : {
        width            ?: number,
        height           ?: number,
        fileSize          : number,
        fileType         ?: string,
    },
    areaInfo             ?: {
        width             : number,
        height            : number,
    },
    photoQualitySettings ?: Types.Common.UiComponents.PhotoDashboard.Models.PhotoQualitySettings,
}):Types.Common.UiComponents.PhotoDashboard.qualityLevels => {

    let imageQuality:Types.Common.UiComponents.PhotoDashboard.qualityLevels = "";

    // base quality from the image area dimensions if known and in a format where pixel dimensions are relevant
    if (imageInfo.width && imageInfo.height && areaInfo?.width && areaInfo?.height
        && !["pdf", "svg"].includes(imageInfo.fileType)
    ) {

        const dpiWidth = imageInfo.width / areaInfo.width;
        const dpiHeight = imageInfo.height / areaInfo.height;
        const dpiAsFill = Math.min(dpiWidth, dpiHeight);

        if (dpiAsFill < 100) imageQuality = "Low";
        else if (dpiAsFill < 200) imageQuality = "Medium";
        else imageQuality = "High";

    }

    // base quality from the file size and legacy quality rules if target area is unknown and rules are provided
    else if (imageInfo.fileSize && photoQualitySettings) {

        const imageQualitySettingsFileType = (imageInfo.fileType === "png") ? "png" : "other";
        const imageQualitySettingsImageSource = photoQualitySettings.forHeadshotOrLogo ? "headshot" : "property";
        const fileSizeOptions = photoQualitySettings[imageQualitySettingsFileType]?.[imageQualitySettingsImageSource];

        if (fileSizeOptions?.low && fileSizeOptions?.medium) {
            if (imageInfo.fileSize < fileSizeOptions.low) imageQuality = "Low";
            else if (imageInfo.fileSize < fileSizeOptions.medium) imageQuality = "Medium";
            else imageQuality = "High";
        }

    }

    return imageQuality;

}